export const NODE_ID_FIELD = 'id';
export const VIEWER_ID_HEADER = 'ComposeDB-ViewerID';
